import type { FaireProductEntity } from "../../entity_types/product";

export const p_vbgpbc5hkp: FaireProductEntity = {
  token: "p_vbgpbc5hkp",
  type: "product",
  name: "Seaside Cottage Studs",
  brandToken: "b_h93v6v8mbm",
  brandName: "Aurora Boheme",
  imageUrl:
    "https://cdn.faire.com/fastly/34e84bb53fa4b2e1a2eff821549e869b87d522d908a38266eba9f93dabc946c0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e7e7b788f1a2d398d5d1610cb91a0368d6a1307006e445d463ee0d9d9a4f2dd0.jpeg",
    "https://cdn.faire.com/fastly/3e982bab56575faf041632057ca67e2efac6070449d2707ed91b73d8a5121e61.jpeg",
    "https://cdn.faire.com/fastly/e7642c7fb798498ef6ce78aa333774631ee605c4e1ee3f3fff8047cd15c6bcdb.jpeg",
  ],
  priceDollars: 12.47,
  description: "",
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:26.777Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
